export default "__VITE_ASSET__DvE0WHwH__"